import { ErrorBaseData } from '.'

export const diseaseErrors: Record<string, ErrorBaseData> = {
  DiseaseNotFoundException: {
    message: 'Patologia não encontrada',
    description: 'Não foi possível encontrar a patologia. Verifique as informações e tente novamente',
  },
}
